import { IController, IScope } from "angular";
import {  } from "@idha/idha-types";
import * as Raven from 'raven-js'
import { utilsModule } from "../../utils-module";
import { City, IGeoDatabase } from "@idha/idha-utils";

/**
 * @ngdoc component
 * @name app.component:citySelector
 * @author William
 * @email william@idha.com.br
 * @description 
 * 
 * <b>IDHA TECNOLOGIA</b>
 * 
 * Nome do Componente: 'citySelector'
 * 
 * Criação: 2019-1-2 16:30:57
 * 
 * Código do componente: CMP0012
 * 
 * Autor:  William 
 * 
 * Componente para informação de cidades, com recurso de autocomplete
 * 
 * @see http://wiki.idha.com.br/index.php/CMP0012_-_Seletor_de_Cidade
 * 
 * @param {string} label label do componente. Se omitido, é considerado 'Cidade'
 * @param {string} ngModel nome da cidade selecionada
 * @param {string} selectionType tipo de seleção. 'UNIQUE' ou 'MULTIPLE'. O valor padrão é 'UNIQUE'.
 * @param {boolean} ngRequired indica se o campo é obrigatório ou não
 * @param {boolean} ngDisabled indica se o campo é desabilitado ou não
 * @param {boolean} showError indica se as mensagens de erro devem ou não ser exibidas
 * @param {string} form nome do formulário em que o componente está inserido
 * @param {string} class classe css a ser aplicada ao componente
 * @param {string} inputName nome do input. Se omitido, o nome "inpCountry" é usado(opcional)
 * @param {Array.City} cityList Lista de cidades a serem exibidas
 * @param {string} countryName Nome do país. É utilizado para filtrar a lista de cidades através do serviço getoDB, caso não tenha sido informado o cityList
 * @param {string} stateSigle Sigla do estado. É utilizado para filtrar a lista de cidades através do serviço getoDB, caso não tenha sido informado o cityList
 * @param {Function} onChangeSelection Callback disparado quando o item selecionado é alterado
 * @param {Function} onChangeText Callback disparado quando o texto do componente é alterado
 */
utilsModule.component('citySelector', {
    template: require('./city-selector.component.html'),
    controller: ['geoDBService','$scope','$timeout',citySelectorController],
    bindings: {
        label: '@?',        
        cityList:'=?',
        countryName:'=?',
        stateSigle:'=?',
        selectionType:'=?',
        ngModel:'=',
        ngRequired:'<?',
        ngDisabled:'=?',
        showError:'<?',
        form:'=?',
        class:'@?',
        inputName:'@?',
        onChangeText:'=',
        onChangeSelection:'='
    }
})

/**
 * @interface
 * @ngdoc controller 
 * @name app.controller:CitySelectorController 
 * @description
 * 
 * Interface do controlador do componente citySelector
 */
export interface CitySelectorController extends IController {
    /**
     * @ngdoc property
     * @name CitySelectorController#label
     * @propertyOf app.controller:CitySelectorController
     * @description
     * 
     * label do componente. Se omitido, é considerado 'Cidade'
     */
    label: string

    /**
     * @ngdoc property
     * @name CitySelectorController#cityList
     * @propertyOf app.controller:CitySelectorController
     * @description
     * 
     * lista de cidades a serem exibidas para seleção
     */
    cityList: City[]

    /**
     * @ngdoc property
     * @name CitySelectorController#countryName
     * @propertyOf app.controller:CitySelectorController
     * @description
     * 
     * Nome do país. É utilizado para filtrar a lista de cidades através do serviço getoDB, caso não tenha sido informado o cityList
     */
    countryName:string

    /**
     * @ngdoc property
     * @name CitySelectorController#stateSigle
     * @propertyOf app.controller:CitySelectorController
     * @description
     * 
     * sigla do estado. É utilizado para filtrar a lista de cidades através do serviço getoDB, caso não tenha sido informado o cityList
     */
    stateSigle:string
    
    /**
     * @ngdoc property
     * @name CitySelectorController#ngModel
     * @propertyOf app.controller:CitySelectorController
     * @description
     * 
     * nome da cidade selecionada
     */
    ngModel:string
    
    /**
     * @ngdoc property
     * @name CitySelectorController#ngRequired
     * @propertyOf app.controller:CitySelectorController
     * @description
     * 
     * indica se o campo é obrigatório ou não
     */
    ngRequired:boolean
    
    /**
     * @ngdoc property
     * @name CitySelectorController#ngDisabled
     * @propertyOf app.controller:CitySelectorController
     * @description
     * 
     * indica se o campo é desabilitado ou não
     */
    ngDisabled:boolean
    
    /**
     * @ngdoc property
     * @name CitySelectorController#showError
     * @propertyOf app.controller:CitySelectorController
     * @description
     * 
     * indica se as mensagens de erro devem ou não ser exibidas
     */
    showError:boolean
    
    /**
     * @ngdoc property
     * @name CitySelectorController#form
     * @propertyOf app.controller:CitySelectorController
     * @description
     * 
     * nome do formulário em que o componente está inserido
     */
    form:string
    
    /**
     * @ngdoc property
     * @name CitySelectorController#searchText
     * @propertyOf app.controller:CitySelectorController
     * @description
     * 
     * texto da busca de cidade
     */
    searchText:string
    
    /**
     * @ngdoc property
     * @name CitySelectorController#class
     * @propertyOf app.controller:CitySelectorController
     * @description
     * 
     * classe css a ser aplicada ao componente
     */
    class:string

    /**
     * @ngdoc property
     * @name CountrySelectorController#inputName
     * @propertyOf app.controller:CitySelectorController
     * @description
     * 
     * nome do input. Se omitido, o nome "inpCity" é usado. 
     * É um parametro opcional
     */
    inputName:string

    /**
     * @ngdoc property
     * @name CitySelectorController#filterCountries
     * @propertyOf app.controller:CitySelectorController
     * @description
     * 
     * Filtra a lista de cidades
     * 
     * @param {string} search texto para filtrar a lista de cidades
     * @return {strin} retorna a lista de cidades derivada da busca
     */
    filterCities:(search:string)=>Promise<string[]>
    
    /**
     * @ngdoc property
     * @name CitySelectorController#onChangeSelection
     * @propertyOf app.controller:CitySelectorController
     * @description
     * 
     * Callback disparado quando o item selecionado é alterado
     */
    onChangeSelection:()=>void

    /**
     * @ngdoc property
     * @name CitySelectorController#onChangeText
     * @propertyOf app.controller:CitySelectorController
     * @description
     * 
     * Callback disparado quando o texto do componente é alterado
     */
    onChangeText:()=>void

    /**
     * @ngdoc property
     * @name CitySelectorController#findCities
     * @propertyOf app.controller:CitySelectorController
     * @description
     * 
     * Atualiza a lista de cidades, com base no país e estado selecionados,
     * acessando o serviço geoDB.
     */
    findCities:()=>Promise<void>

    /**
     * @ngdoc property
     * @name CitySelectorController#onChangeText
     * @propertyOf app.controller:CitySelectorController
     * @description
     * 
     * Callback disparado quando o texto do componente é alterado
     */
    onBlur:()=>void
}


/**
 * @name app.controller:citySelectorController 
 * @implements CitySelectorController 
 * @description
 * 
 * Controlador do componente citySelector
 */
function citySelectorController(geoDBService:IGeoDatabase,$scope:IScope,$timeout:any) {
    var ctrl: CitySelectorController = this;


    ctrl.$onInit = async function(){
        if(!ctrl.inputName) ctrl.inputName = 'inpCity';

        if(!ctrl.cityList){            
            ctrl.findCities();

            $scope.$watch(()=>ctrl.countryName,()=>{
                ctrl.cityList = undefined;
                ctrl.findCities();
            })
            $scope.$watch(()=>ctrl.stateSigle,()=>{
                ctrl.cityList = undefined;
                ctrl.findCities();
            })            
        }

        /*
        * @TODO: Trecho necessário devido a um bug no ng-required, no qual quando o mesmo é inicializado com FALSE,
        * o  mesmo é ignorado e a validação é feita, a menos que entre no campo, digite algo e depois apague.
        * Este trecho faz com que, nesses casos, a validação '''Required''' seja forçada para TRUE, indicando 
        * que o formulário é valido.
        * 
        * O timeout é utilizado sem parametro de tempo para garantir apenas que seja executado apos o ciclo de $digest,
        * onde os campos do formulario ja foram todos criados.    
        */
        $timeout(()=>{
            if(ctrl.form && ctrl.form[ctrl.inputName]){
                if(!ctrl.ngRequired){
                    ctrl.form[ctrl.inputName].$setValidity('required', true);
                }
            }
        })
    }

    ctrl.findCities = async function():Promise<void>{      
        try{  
            if(ctrl.countryName && ctrl.stateSigle){
                ctrl.cityList = await geoDBService.listCities(ctrl.countryName,ctrl.stateSigle,"NAME","SIGLE");
                ctrl.cityList.sort((city1:City,city2:City)=>{
                    return city1.name.localeCompare(city2.name);
                })
            }        
        }catch(e){
            console.log(e);
        }
    }

    ctrl.filterCities = async function(searchText:string):Promise<string[]>{    
        if(!ctrl.cityList) return [];

        if(searchText.length < 3) return [];

        await ctrl.cityList; //Espera resolver a lista de cidades, acaso ainda nao tenha resolvido        

        return ctrl.cityList.filter((city:City)=>{
            return city.name.toUpperCase().indexOf(searchText.toUpperCase()) > -1
        }).map((city:City)=>{
            return city.name
        })
    }

    ctrl.onBlur = function(){
        if(!ctrl.ngModel) ctrl.ngModel = ctrl.searchText;
    }
}